import React from 'react';
import { Checkbox } from '@naf-simba/elements-checkbox';
import { Controller } from 'react-hook-form';
import { TextVariant } from '@naf/text';
import xor from 'lodash/xor';
import { formattedPrice } from '@lib/formattedPrice';
import { useTrackProductsCart } from '../../../../../hooks/useTrackProductItem';
import type { AddonFormMember } from '../Addons.utils';
import S from './Styles';
import { AddonProductFormFields } from './AddonProductFormFields';
import { AddonProductVariantProps } from './AddonProductField.types';

interface IndividualPaymentProductFieldProps extends AddonProductVariantProps {
  members: AddonFormMember[];
  tracking: ReturnType<typeof useTrackProductsCart>;
}

export const IndividualPaymentProductField = ({
  product,
  members,
  selectedMembers,
  storedMembers,
  control,
  errors,
  watch,
  setValue,
  tracking,
}: IndividualPaymentProductFieldProps) => (
  <S.FieldWrapper $error={!!errors[product.productNumber]}>
    <Controller
      name={`${product.productNumber}.members`}
      control={control}
      defaultValue={storedMembers || []}
      render={({ field: { value, onChange } }) => {
        const currentPrice = product.productAppPrice[value.length.toString()]?.itemTotalPrice || 0;
        const nextPrice = product.productAppPrice[(value.length + 1).toString()]?.itemTotalPrice || 0;
        const priceDifference = nextPrice - currentPrice;
        return (
          <S.CheckboxWrapper>
            <S.LabelWrapper>
              <S.StyledLabel variant={TextVariant.ArticleTextSubHeader}>{product.productName}</S.StyledLabel>
              {product.shortDescription ? <S.StyledTooltip title={product.shortDescription} /> : null}
            </S.LabelWrapper>
            <S.PriceSubLabel>
              {priceDifference > 0 ? `+ ${formattedPrice(priceDifference)} kr per pers` : 'Gratis'}
            </S.PriceSubLabel>
            {members.map((member, index) => {
              const memberIndex = index.toString();
              return (
                <Checkbox
                  label={
                    `${member?.firstName || ''} ${member?.lastName || ''}`.trim() || `Husstandsmedlem ${index + 1}`
                  }
                  name={`${member?.firstName}-${member?.lastName}`}
                  key={`${product.productNumber}-${member?.firstName}-${member?.lastName}`}
                  checked={value.includes(memberIndex)}
                  onChange={() => {
                    if (value.includes(memberIndex)) tracking.trackRemoveFromCart(product, 'Medlemskap', 'Innmelding');
                    else tracking.trackAddToCart(product, 'Medlemskap', 'Innmelding');
                    onChange(xor(value, [memberIndex]));
                  }}
                />
              );
            })}
          </S.CheckboxWrapper>
        );
      }}
    />
    {!!selectedMembers?.length && (
      <S.FormFieldsWrapper>
        <AddonProductFormFields product={product} control={control} errors={errors} watch={watch} setValue={setValue} />
      </S.FormFieldsWrapper>
    )}
  </S.FieldWrapper>
);
